import type { CSSProperties } from 'react'
import { renderConnectedSummaryLine, type ConnectedSummaryLinesProps } from './ConnectedSummaryLines'

export type { ConnectedSummaryLine, ConnectedSummaryLinesInput, ConnectedSummaryLinesProps } from './ConnectedSummaryLines'

const DEFAULT_CONNECTOR_COLOR = '#F0F4F7'
const DEFAULT_CONNECTOR_THICKNESS = 1.5
const DEFAULT_LINE_HEIGHT = 15
const DEFAULT_GAP = 0

export function ConnectedSummaryLinesV2({
  lines,
  connectorColor = DEFAULT_CONNECTOR_COLOR,
  connectorThickness = DEFAULT_CONNECTOR_THICKNESS,
  lineHeight = DEFAULT_LINE_HEIGHT,
  gap = DEFAULT_GAP,
  className = '',
  lineClassName = '',
}: ConnectedSummaryLinesProps) {
  if (lines.length === 0) {
    return null
  }

  const normalizedLines = lines.map((line) => (typeof line === 'string' ? { html: line } : line))

  const treeStyle = {
    '--csl-connector-color': connectorColor,
    '--csl-connector-thickness': `${connectorThickness}px`,
    '--csl-hook-height': `${lineHeight}px`
  } as CSSProperties

  return (
    <div
      className={`text-[13px] text-[#6A6E6E] ${className}`.trim()}
      style={treeStyle}
    >
      <ul className="m-0 flex list-none flex-col pl-[14px]" style={{ gap }}>
        {normalizedLines.map((line, lineIndex) => {
          const isLastLine = lineIndex === normalizedLines.length - 1
          const lineStyle = isLastLine
            ? undefined
            : ({ '--csl-trail-extension': `-${gap}px` } as CSSProperties)

          return (
            <li
              key={lineIndex}
              style={lineStyle}
              className={[
                'relative before:pointer-events-none before:absolute before:top-0 before:-left-[13px] before:z-[1] before:h-[var(--csl-hook-height)] before:w-[13px] before:rounded-bl-[6px]',
                "before:border-b before:border-l before:border-solid before:[border-bottom-color:var(--csl-connector-color)] before:[border-bottom-width:var(--csl-connector-thickness)] before:[border-left-color:var(--csl-connector-color)] before:[border-left-width:var(--csl-connector-thickness)] before:content-['']",
                'after:pointer-events-none after:absolute after:top-0 after:-left-[13px] after:bottom-[var(--csl-trail-extension)] after:z-[1]',
                "after:border-l after:border-solid after:[border-left-color:var(--csl-connector-color)] after:[border-left-width:var(--csl-connector-thickness)] after:content-[''] last:after:hidden"
              ].join(' ')}
            >
              <div
                className={`relative z-[2] min-w-0 ml-[8px] mt-[3px] 
                ${line.onClick ? 'cursor-pointer' : ''} ${lineClassName}`.trim()}
                onClick={line.onClick}
              >
                {renderConnectedSummaryLine(line)}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
